// Register GSAP plugins once at module level (desktop-only sections guard internally)
if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger);
}

// ===============================
// About Banner Slider (Splide)
// ===============================
(function () {
  let aboutSwiper = null;

  function initAboutSwiper() {
    const swiperContainer = document.querySelector(".about-banner-slider .swiper-container");

    if (
      typeof Swiper !== "undefined" &&
      typeof window.swiperEnabled !== "undefined" &&
      swiperContainer
    ) {
      // Prevent multiple initializations
      if (swiperContainer.swiper) {
        aboutSwiper = swiperContainer.swiper;
        return;
      }

      aboutSwiper = new Swiper(swiperContainer, {
        loop: true,
        effect: "slide",
        parallax: true,
        speed: window.innerWidth <= 768 ? 3000 : 1800,
        autoplay: window.innerWidth <= 768 ? { delay: 0 } : false,
        // Let vertical swipes reach section-transition (required on iOS).
        allowTouchMove: false,
        simulateTouch: false,
        on: {
          slideChangeTransitionStart: function () {
            // Optional logic
          },
        },
      });

      if (window.innerWidth > 768) {
        setTimeout(() => {
          aboutSwiper.params.autoplay = {
            delay: 1000,
            disableOnInteraction: false,
          };
          aboutSwiper.autoplay.start();

          aboutSwiper.on("slideChange", function () {
            aboutSwiper.params.autoplay.delay = aboutSwiper.params.speed + 2000;
          });
        }, 2000);
      }
    }
  }

  // Resume autoplay when returning to tab
  function resumeSwiperAutoplay() {
    if (document.visibilityState === "visible" && aboutSwiper?.autoplay) {
      aboutSwiper.autoplay.start();
    }
  }

  // Init on full load
  document.addEventListener("DOMContentLoaded", function () {
    initAboutSwiper();
  });

  // For page transitions (Swup, Barba, etc.)
  document.addEventListener("page:loaded", function () {
    initAboutSwiper();
  });

  // Resume autoplay when tab becomes active
  document.addEventListener("visibilitychange", resumeSwiperAutoplay);
})();

// ===============================
// About CEO Video
// ===============================
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const videoWrappers = document.querySelectorAll(".about_ceo_wrapper");
    if (!videoWrappers.length) return;

    const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
    const mobileSourceMq = window.matchMedia("(max-width: 1023px)");

    function getDirectorVideoSource(video) {
      const desktopSrc = video.dataset.srcDesktop || "";
      const mobileSrc = video.dataset.srcMobile || "";
      const useMobile = mobileSourceMq.matches;

      if (useMobile && mobileSrc) {
        return {
          src: mobileSrc,
          type: video.dataset.typeMobile || "video/mp4",
        };
      }
      if (desktopSrc) {
        return {
          src: desktopSrc,
          type: video.dataset.typeDesktop || "video/mp4",
        };
      }
      if (mobileSrc) {
        return {
          src: mobileSrc,
          type: video.dataset.typeMobile || "video/mp4",
        };
      }
      return null;
    }

    function applyDirectorVideoSource(video) {
      const chosen = getDirectorVideoSource(video);
      if (!chosen) return false;

      if (video.dataset.activeSrc === chosen.src) {
        return true;
      }

      video.dataset.activeSrc = chosen.src;
      video.pause();
      video.removeAttribute("src");
      Array.from(video.querySelectorAll("source")).forEach((node) => node.remove());

      // Direct src is the most reliable path on iOS Safari.
      video.src = chosen.src;
      video.load();
      return true;
    }

    function enableDirectorVideoForIOS(video) {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute("playsinline", "");
      video.setAttribute("webkit-playsinline", "");
      video.setAttribute("muted", "");
      video.loop = false;
    }

    function setupDirectorVideoEnd(video) {
      if (video.dataset.endHandlerBound === "true") return;
      video.dataset.endHandlerBound = "true";
      video.loop = false;

      video.addEventListener("ended", function () {
        video.pause();
        if (!Number.isFinite(video.duration) || video.duration <= 0) return;

        const holdOnLastFrame = () => {
          try {
            video.currentTime = Math.max(0, video.duration - 0.001);
          } catch (err) {
            // iOS can reject seeks until metadata is stable.
          }
        };

        if (video.readyState >= 1) {
          holdOnLastFrame();
        } else {
          video.addEventListener("loadedmetadata", holdOnLastFrame, { once: true });
        }
      });
    }

    // Only replay from the start after the user returns to section 1 (top) and scrolls down again.
    let shouldResetDirectorVideo = true;

    function playDirectorVideo(wrapper, fromStart) {
      const video = wrapper.querySelector(".director-video");
      if (!video) return;

      setupDirectorVideoEnd(video);
      enableDirectorVideoForIOS(video);
      applyDirectorVideoSource(video);

      const attemptPlay = () => {
        enableDirectorVideoForIOS(video);

        if (video.ended && !fromStart) {
          return;
        }

        if (fromStart) {
          try {
            video.currentTime = 0;
          } catch (err) {
            // iOS may reject seeks until metadata is ready.
          }
        }

        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(() => {
            video.addEventListener(
              "canplay",
              () => {
                if (fromStart) {
                  try {
                    video.currentTime = 0;
                  } catch (err) {
                    // Ignore seek errors on retry.
                  }
                }
                video.play().catch(() => {});
              },
              { once: true }
            );
          });
        }
      };

      if (fromStart || video.readyState < 2) {
        if (video.readyState >= 2 && fromStart) {
          attemptPlay();
          return;
        }
        video.addEventListener("loadeddata", attemptPlay, { once: true });
        video.addEventListener("canplay", attemptPlay, { once: true });
        return;
      }

      attemptPlay();
    }

    function pauseDirectorVideo(wrapper) {
      const video = wrapper.querySelector(".director-video");
      if (video) video.pause();
    }

    function playDirectorVideosWhenVisible(fromStart) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          videoWrappers.forEach((wrapper) => playDirectorVideo(wrapper, fromStart));
        });
      });
    }

    function onSection2Activated() {
      const fromStart = shouldResetDirectorVideo;
      shouldResetDirectorVideo = false;
      playDirectorVideosWhenVisible(fromStart);
    }

    videoWrappers.forEach((wrapper) => {
      const video = wrapper.querySelector(".director-video");
      if (!video) return;
      setupDirectorVideoEnd(video);
      enableDirectorVideoForIOS(video);
      applyDirectorVideoSource(video);
    });

    document.addEventListener("section2Activated", onSection2Activated);

    document.addEventListener("section1Activated", () => {
      shouldResetDirectorVideo = true;
      videoWrappers.forEach(pauseDirectorVideo);
    });

    if (document.body.classList.contains("section2-active")) {
      onSection2Activated();
    }

    document.addEventListener("visibilitychange", () => {
      if (document.hidden || !document.body.classList.contains("section2-active")) {
        return;
      }
      videoWrappers.forEach((wrapper) => playDirectorVideo(wrapper, false));
    });

    if (typeof mobileSourceMq.addEventListener === "function") {
      mobileSourceMq.addEventListener("change", () => {
        videoWrappers.forEach((wrapper) => {
          const video = wrapper.querySelector(".director-video");
          if (!video) return;
          delete video.dataset.activeSrc;
          applyDirectorVideoSource(video);
        });
        if (document.body.classList.contains("section2-active")) {
          playDirectorVideosWhenVisible(false);
        }
      });
    } else if (typeof mobileSourceMq.addListener === "function") {
      mobileSourceMq.addListener(() => {
        videoWrappers.forEach((wrapper) => {
          const video = wrapper.querySelector(".director-video");
          if (!video) return;
          delete video.dataset.activeSrc;
          applyDirectorVideoSource(video);
        });
        if (document.body.classList.contains("section2-active")) {
          playDirectorVideosWhenVisible(false);
        }
      });
    }

    videoWrappers.forEach((wrapper) => {
      const customCursor = wrapper.querySelector(".custom-cursor");
      const arrowCursor = wrapper.querySelector(".arrow-cursor");
      const founderQuote = wrapper.querySelector(".founder-quote");
      const cursorOffset = 33.5;

      if (!wrapper.querySelector(".director-video")) return;

      let quoteTimeline;

      if (isDesktop && customCursor && arrowCursor) {
        let cursorX = 0, cursorY = 0;
        let mouseX = 0, mouseY = 0;
        let cursorAnimationFrame;
        let isCursorActive = false;
        let isSection2Active = false;

        // Initialize cursor position at center
        const bounds = wrapper.getBoundingClientRect();
        mouseX = bounds.width / 2 - cursorOffset;
        mouseY = bounds.height / 2 - cursorOffset;
        cursorX = mouseX;
        cursorY = mouseY;

        function animateCursor() {
          if (!isCursorActive || !isSection2Active) return;
          
          cursorX += (mouseX - cursorX) * 0.15; // Increased from 0.1 for more responsive movement
          cursorY += (mouseY - cursorY) * 0.15;

          customCursor.style.transform = `translate3d(${cursorX}px, ${cursorY}px, 0)`;
          arrowCursor.style.transform = `translate3d(${cursorX + cursorOffset}px, ${cursorY + cursorOffset}px, 0)`;

          cursorAnimationFrame = requestAnimationFrame(animateCursor);
        }

        function showCursor(x, y) {
          isCursorActive = true;
          customCursor.classList.add("show");
          arrowCursor.style.opacity = 1;

          // Set initial position immediately for instant response
          mouseX = x - cursorOffset;
          mouseY = y - cursorOffset;
          cursorX = mouseX;
          cursorY = mouseY;
          customCursor.style.transform = `translate3d(${cursorX}px, ${cursorY}px, 0)`;
          arrowCursor.style.transform = `translate3d(${cursorX + cursorOffset}px, ${cursorY + cursorOffset}px, 0)`;

          if (!cursorAnimationFrame) {
            cursorAnimationFrame = requestAnimationFrame(animateCursor);
          }
        }

        function hideCursor() {
          isCursorActive = false;
          customCursor.classList.remove("show");
          arrowCursor.style.opacity = 0;
          
          if (cursorAnimationFrame) {
            cancelAnimationFrame(cursorAnimationFrame);
            cursorAnimationFrame = null;
          }
        }

        wrapper.addEventListener("mousemove", (e) => {
          if (!isSection2Active) return;
          const rect = wrapper.getBoundingClientRect();
          mouseX = e.clientX - rect.left - cursorOffset;
          mouseY = e.clientY - rect.top - cursorOffset;
        });

        wrapper.addEventListener("mouseleave", () => {
          hideCursor();
        });

        wrapper.addEventListener("mouseenter", (e) => {
          if (isSection2Active) {
            showCursor(e.clientX, e.clientY);
          }
        });

        // Start cursor animation when section 2 is activated
        document.addEventListener("section2Activated", () => {
          isSection2Active = true;
          // Position cursor at center initially
          const centerX = window.innerWidth / 2;
          const centerY = window.innerHeight / 2;
          showCursor(centerX, centerY);
        });

        // Stop cursor animation when transitioning back to section 1
        document.addEventListener("section1Activated", () => {
          isSection2Active = false;
          hideCursor();
        });
      }

      // Quote animation triggered by section2 activation
      document.addEventListener("section2Activated", () => {
        if (founderQuote && !founderQuote.classList.contains("quote-bound")) {
          founderQuote.classList.add("quote-bound");

          const textEl = founderQuote.querySelector("h3");
          if (textEl) {
            const words = textEl.textContent.trim().split(" ");
            textEl.innerHTML = words
              .map(word => `<span class="quote-word">${word}</span>`)
              .join(" ");

            const wordSpans = textEl.querySelectorAll(".quote-word");

            // Check if mobile device for faster animation
            const isMobile = window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            
            quoteTimeline = gsap.timeline({ paused: true });
            quoteTimeline.fromTo(
              wordSpans,
              { y: 20, opacity: 0 },
              {
                y: 0,
                opacity: 1,
                stagger: isMobile ? 0.03 : 0.07, // Faster stagger on mobile
                ease: "power3.out",
                duration: isMobile ? 0.4 : 0.7 // Faster duration on mobile
              }
            );

            founderQuote.classList.add("visible");
            quoteTimeline.play(0);
          }
        }
      });

    });

    window.addEventListener("orientationchange", () => {
      setTimeout(() => {
        videoWrappers.forEach((wrapper) => {
          const video = wrapper.querySelector(".director-video");
          if (!video) return;
          delete video.dataset.activeSrc;
          applyDirectorVideoSource(video);
        });
        if (document.body.classList.contains("section2-active")) {
          playDirectorVideosWhenVisible(false);
        }
      }, 300);
    });
  });
})();

// ===============================
//Team Member Fade in Animaiton
// ===============================
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          // Add staggered delay using setTimeout
          setTimeout(() => {
            entry.target.classList.add('is-visible');
          }, index * 200); // 200ms stagger delay per item
        }
      });
    }, { threshold: 0.3 });

    document.querySelectorAll('.team__member').forEach(el => observer.observe(el));
  });
})();

// ===============================
//Counter
// ===============================
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    // On mobile: render final values immediately, skip GSAP entirely
    if (window.innerWidth <= 768) {
      var yearsEl = document.querySelector('#years');
      var stonesEl = document.querySelector('#stones');
      if (yearsEl) yearsEl.textContent = '35+';
      if (stonesEl) stonesEl.textContent = '600+';
      return;
    }

    function createOdometer(elementSelector, finalValue, duration) {
      const element = document.querySelector(elementSelector);
      if (!element) return;

      // Otherwise, build animated odometer
      element.innerHTML = '';
      const digits = finalValue.toString().split('');

      digits.forEach((digit) => {
        const container = document.createElement('div');
        container.className = 'digit-container';

        const wrapper = document.createElement('div');
        wrapper.className = 'digit';

        for (let j = 0; j <= 9; j++) {
          const span = document.createElement('span');
          span.textContent = j;
          wrapper.appendChild(span);
        }

        wrapper.style.transform = 'translateY(0%)';
        container.appendChild(wrapper);
        element.appendChild(container);

        ScrollTrigger.create({
          trigger: element,
          start: 'top 80%',
          once: true,
          onEnter: () => {
            gsap.to(wrapper, {
              y: `-${digit}em`,
              duration,
              ease: 'power2.out',
            });
          },
        });
      });

      const plus = document.createElement('span');
      plus.className = 'plus-sign';
      plus.textContent = '+';
      element.appendChild(plus);
    }

    createOdometer('#years', 35, 2);
    createOdometer('#stones', 600, 2);
  });
})();


// ===============================
// About Insights Slider
// ===============================
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    var insightsSlider = document.querySelector(".abt-insights-slider");
    if (!insightsSlider) return;

    var insightsSplide = null;

    function isMobileInsights() {
      return window.matchMedia("(max-width: 768px)").matches;
    }

    function loadInsightsSliderImages() {
      insightsSlider.querySelectorAll("img").forEach(function (img) {
        img.classList.remove("lazy-defer", "lazy-loading");
        img.classList.add("lazy-loaded");
        img.setAttribute("loading", "eager");

        if (img.getAttribute("data-src")) {
          img.setAttribute("src", img.getAttribute("data-src"));
          img.removeAttribute("data-src");
        }
      });
    }

    function getInsightsSplideOptions() {
      if (isMobileInsights()) {
        return {
          type: "slide",
          perPage: 1,
          perMove: 1,
          gap: "16px",
          arrows: false,
          pagination: false,
          drag: true,
          focus: "center",
          padding: { left: "6%", right: "14%" },
        };
      }

      return {
        type: "loop",
        perPage: 3,
        arrows: false,
        pagination: false,
        gap: "20px",
        drag: "free",
        breakpoints: {
          1024: {
            perPage: 3,
          },
        },
        autoScroll: {
          speed: 1,
          pauseOnHover: false,
          pauseOnFocus: false,
        },
      };
    }

    function playInsightsAutoScroll() {
      if (
        isMobileInsights() ||
        !insightsSplide ||
        !insightsSplide.Components ||
        !insightsSplide.Components.AutoScroll
      ) {
        return;
      }
      insightsSplide.Components.AutoScroll.play();
    }

    function refreshInsightsSlider() {
      if (!insightsSplide) return;
      insightsSplide.refresh();
      playInsightsAutoScroll();
    }

    function initInsightsSlider() {
      if (insightsSlider.getAttribute("data-insights-splide-init") === "1") {
        refreshInsightsSlider();
        return;
      }
      insightsSlider.setAttribute("data-insights-splide-init", "1");

      loadInsightsSliderImages();
      insightsSlider.style.visibility = "visible";

      insightsSplide = new Splide(insightsSlider, getInsightsSplideOptions());

      var hasAutoScrollExt =
        !isMobileInsights() &&
        window.splide &&
        window.splide.Extensions &&
        window.splide.Extensions.AutoScroll;

      if (hasAutoScrollExt) {
        insightsSplide.mount(window.splide.Extensions);
      } else {
        insightsSplide.mount();
      }

      insightsSplide.on("mounted", function () {
        insightsSlider.classList.add("is-insights-splide-mounted");
        loadInsightsSliderImages();
        window.requestAnimationFrame(function () {
          if (insightsSplide) {
            insightsSplide.refresh();
            insightsSplide.go(0);
          }
          playInsightsAutoScroll();
        });
      });

      insightsSlider.querySelectorAll("img").forEach(function (img) {
        if (img.complete) return;
        img.addEventListener("load", refreshInsightsSlider, { once: true });
      });

      if (!isMobileInsights()) {
        window.setTimeout(refreshInsightsSlider, 150);
        window.setTimeout(refreshInsightsSlider, 600);
      }
    }

    function bootInsightsSlider() {
      loadInsightsSliderImages();
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(initInsightsSlider);
      });
    }

    if (isMobileInsights()) {
      // Defer to window.load on mobile — slider is below fold, no need to block DOMContentLoaded
      window.addEventListener("load", function () {
        bootInsightsSlider();
        refreshInsightsSlider();
      });
    } else if ("IntersectionObserver" in window) {
      var insightsObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            bootInsightsSlider();
            insightsObserver.unobserve(insightsSlider);
          });
        },
        {
          threshold: 0.1,
          rootMargin: "200px 0px 200px 0px",
        }
      );
      insightsObserver.observe(insightsSlider);
    } else {
      bootInsightsSlider();
    }
  });
})();


// ===============================
// About Awards Slider (defer mount until in view; images use real src in markup so Splide loop clones stay valid)
// ===============================
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const bannerSlider = document.querySelector(".abt-awards-slider");
    if (!bannerSlider) return;

    function initAwardsSlider() {
      if (bannerSlider.getAttribute("data-awards-splide-init") === "1") {
        return;
      }
      bannerSlider.setAttribute("data-awards-splide-init", "1");

      var splide = new Splide(bannerSlider, {
        type: "loop",
        perPage: 4,
        arrows: false,
        pagination: false,
        focus: "center",
        gap: "30px",
        breakpoints: {
          768: {
            perPage: 2,
            focus: "center",
            gap: "40px",
          },
        },
        autoScroll: {
          pauseOnHover: false,
          pauseOnFocus: false,
        },
      });

      var hasAutoScrollExt =
        window.splide &&
        window.splide.Extensions &&
        window.splide.Extensions.AutoScroll;

      if (hasAutoScrollExt) {
        splide.mount(window.splide.Extensions);
      } else {
        splide.mount();
      }

      splide.on("mounted", function () {
        bannerSlider.classList.add("is-awards-splide-mounted");
      });
    }

    if ("IntersectionObserver" in window) {
      var awardsObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              initAwardsSlider();
              awardsObserver.unobserve(bannerSlider);
            }
          });
        },
        {
          threshold: 0,
          rootMargin: "0px 0px 25% 0px",
        }
      );
      awardsObserver.observe(bannerSlider);
    } else {
      initAwardsSlider();
    }
  });
})();

// ===============================
//About Tab + Slider
// ===============================
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const tabWrapper = document.querySelector('.branch-network-wrapper');
    if (!tabWrapper) return;

    const tabMenu = tabWrapper.querySelector('.tab-menu');
    const tabItems = tabWrapper.querySelectorAll('.tab-items');
    const tabButtons = tabMenu.querySelectorAll('li');

    if (!tabMenu || !tabItems.length || !tabButtons.length) return;

    let swiperStarted = false;

    // Add click event listeners to tab buttons
    tabButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        swiperStarted = true;
        showTab(index);
      });
    });

    // Initialize first tab only once the section enters the viewport
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !swiperStarted) {
        swiperStarted = true;
        showTab(0);
        observer.disconnect();
      }
    }, { threshold: 0 });

    observer.observe(tabWrapper);

    function showTab(index) {
      // Remove active class from all tabs and buttons
      tabItems.forEach(item => item.style.display = 'none');
      tabButtons.forEach(btn => btn.classList.remove('tab-active'));

      // Show selected tab and activate button
      if (tabItems[index]) {
        tabItems[index].style.display = 'block';
        tabButtons[index].classList.add('tab-active');

        // Initialize swiper for the active tab
        refreshSwiperForTab(tabItems[index]);
      }
    }
  });
})();

function refreshSwiperForTab(tabItem) {
  const swiperContainer = tabItem.querySelector('.swiper-container');
  const paginationContainer = tabItem.querySelector('.custom-pagination');

  if (!swiperContainer) return;

  // Destroy existing Swiper instance
  if (swiperContainer.swiper) {
    swiperContainer.swiper.destroy(true, true);
  }

  // Clear existing pagination
  if (paginationContainer) paginationContainer.innerHTML = '';

  const slides = swiperContainer.querySelectorAll('.swiper-slide');
  const thumbs = [];

  // Build thumbnail buttons dynamically
  if (paginationContainer && slides.length) {
    slides.forEach((slide, index) => {
      const img = slide.querySelector('img');
      if (!img) return;

      const button = document.createElement('button');
      button.setAttribute('type', 'button');
      button.setAttribute('data-index', index);
      button.innerHTML = `<img src="${img.src}" alt="thumb-${index + 1}" loading="lazy" decoding="async">`;

      paginationContainer.appendChild(button);
      thumbs.push(button);
    });
  }

  // Initialize Swiper
  const swiper = new Swiper(swiperContainer, {
    loop: true,
    effect: 'slide',
    parallax: true,
    speed: 1000,
    autoplay: {
      delay: 1500,
      disableOnInteraction: false,
    },
    on: {
      init: function () {
        this.autoplay.start();
        updateActiveThumb(this.realIndex);
      },
      slideChange: function () {
        this.params.autoplay.delay = this.params.speed + 2000;
        updateActiveThumb(this.realIndex);
      },
    },
  });

  // Navigate to slide on thumbnail click
  thumbs.forEach((thumb, i) => {
    thumb.addEventListener('click', () => {
      if (swiper.realIndex === i) return;
      swiper.autoplay.stop();

      const total = thumbs.length;
      const current = swiper.realIndex;
      const forward = (i - current + total) % total;
      const backward = (current - i + total) % total;

      if (forward === 1) {
        // One step forward — use slideNext so the loop wraps cleanly
        swiper.slideNext();
      } else if (backward === 1) {
        // One step backward — use slidePrev so the loop wraps cleanly
        swiper.slidePrev();
      } else {
        swiper.slideToLoop(i);
      }

      swiper.autoplay.start();
    });
  });

  function updateActiveThumb(index) {
    thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('active-thumb', i === index);
    });
  }
}

// ===============================
//About Team Popup
// ===============================
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const members = document.querySelectorAll(".team__member");
    const modal = document.getElementById("teamModal");

    if (!modal) {
      return;
    }

    const closeBtn = document.getElementById("teamModalClose");
    const modalImage = document.getElementById("teamModalImage");
    const modalName = document.getElementById("teamModalName");
    const modalTitle = document.getElementById("teamModalTitle");
    const modalDescription = document.getElementById("teamModalDescription");

    function openModal(member) {
      const imgEl = member.querySelector(".team__image");
      const nameEl = member.querySelector(".heading-4");
      const titleEl = member.querySelector(".label-1");
      const bioEl = member.querySelector(".team__bio");

      if (imgEl && modalImage) {
        modalImage.src = imgEl.src;
        modalImage.alt = imgEl.alt || '';
      }

      if (nameEl && modalName) modalName.textContent = nameEl.textContent;
      if (titleEl && modalTitle) modalTitle.textContent = titleEl.textContent;
      if (bioEl && modalDescription) modalDescription.innerHTML = bioEl.innerHTML;

      modal.classList.add("open");
      
      // Only prevent body scrolling on desktop, allow mobile modal to scroll
      const isMobile = window.innerWidth <= 768;
      if (!isMobile) {
        document.body.classList.add("no-scroll");
        if (window.lenis) window.lenis.stop();
      }
    }

    function closeModal() {
      modal.classList.remove("open");
      modal.classList.add("closing");
      
      // Only restore body scrolling on desktop
      const isMobile = window.innerWidth <= 768;
      if (!isMobile) {
        document.body.classList.remove("no-scroll");
        if (window.lenis) window.lenis.start();
      }

      setTimeout(() => {
        modal.classList.add("fading");
      }, 550); 

      setTimeout(() => {
        modal.classList.remove("closing", "fading");
      }, 850); 
    }

    members.forEach((member) => {
      if (member.classList.contains("team__member--no-bio") || !member.querySelector(".team__bio")) return;
      member.addEventListener("click", () => openModal(member));
    });

    if (closeBtn) {
      closeBtn.addEventListener("click", closeModal);
    } else {
      console.warn('Element with ID "teamModalClose" not found.');
    }

    modal.addEventListener("click", (e) => {
      if (e.target === modal) {
        closeModal();
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        closeModal();
      }
    });
  });
})();

// ===============================
// Reusable Word Animation Module
// ===============================
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
    if (!isDesktop) return;

    function animateVisionaries(containerSelector) {
      const container = document.querySelector(containerSelector);
      if (!container) return;

      const h3 = container.querySelector("h3");
      const ps = container.querySelectorAll("p");

      const wrapInSpan = (el) => {
        const span = document.createElement("span");
        span.classList.add("reveal-block");
        span.innerHTML = el.innerHTML;
        el.innerHTML = "";
        el.appendChild(span);
        return span;
      };

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          start: "top 85%",
          once: true
        }
      });

      // Wrap h3 and p tags in spans
      const h3Span = wrapInSpan(h3);
      const pSpans = [];

      ps.forEach(p => {
        const span = wrapInSpan(p);
        pSpans.push(span);
      });

      // Initial state
      gsap.set([h3Span, ...pSpans], { y: 100, opacity: 0 });

      // Animate h3 (slower, smoother)
      tl.to(h3Span, {
        y: 0,
        opacity: 1,
        ease: "power1.out",     // smoother ease
        duration: 0.8           // increased from 0.5
      }, 0);

      // Animate p tags together (slower, smoother)
      tl.to(pSpans, {
        y: 0,
        opacity: 1,
        ease: "power1.out",
        duration: 0.8
      }, ">-0.1"); // slight overlap for fluidity
    }

    // animateVisionaries(".visionaries_title"); // Text animation removed
  });
})();

// ===============================
// Visionaries Split Animation
// ===============================
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    // Below-fold scroll animation — not needed on mobile
    if (window.innerWidth <= 768) return;

    const visionariesTitle = document.querySelector(".visionaries_title");
    if (!visionariesTitle) return;

    const h3 = visionariesTitle.querySelector("h3");
    const paragraphs = visionariesTitle.querySelectorAll("p");

    if (!h3 || !paragraphs.length) return;

    // Set initial state for h3 and paragraphs
    gsap.set([h3, ...paragraphs], {
      y: 100,
      opacity: 0
    });

    // Create animation timeline
    ScrollTrigger.create({
      trigger: visionariesTitle,
      start: "top 80%",
      end: "bottom center",
      once: true,
      onEnter: () => {
        // Animate h3 first
        gsap.to(h3, {
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: "power2.out"
        });

        // Then animate paragraphs with slight delay
        gsap.to(paragraphs, {
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: "power2.out",
          stagger: 0.2,
          delay: 0.3
        });
      }
    });
  });
})();

// Map click interactions on mobile — exposed globally so lazy-loaded SVGs can be initialised after injection
window.mciInitMaps = function () {
  if (window.innerWidth > 768) return;

  function initMapClicks(svg) {
    if (!svg) return;

    var circles = svg.querySelectorAll('.circle');
    var activeLocation = null;
    var activeDashed   = null;

    function deactivateAll() {
      if (activeLocation) { activeLocation.classList.remove('active'); activeLocation = null; }
      if (activeDashed)   { activeDashed.classList.remove('active');   activeDashed   = null; }
    }

    circles.forEach(function (circle) {
      circle.style.cursor = 'pointer';

      circle.addEventListener('click', function (e) {
        e.stopPropagation();

        var location = null;
        var dashed   = null;
        var sibling  = circle.nextElementSibling;

        while (sibling) {
          if (sibling.classList.contains('dashed')   && !dashed)   dashed   = sibling;
          if (sibling.classList.contains('location') && !location) location = sibling;
          sibling = sibling.nextElementSibling;
        }

        if (activeLocation && activeLocation === location) {
          deactivateAll();
          return;
        }

        deactivateAll();

        if (location) { location.classList.add('active'); activeLocation = location; }
        if (dashed)   { dashed.classList.add('active');   activeDashed   = dashed;   }
      });
    });

    svg.addEventListener('click', deactivateAll);
  }

  // First map — scrollable, scroll to show Bangalore
  var mapScroll = document.querySelector('.map-svg-scroll');
  if (mapScroll) {
    var svg = mapScroll.querySelector('svg');
    var svgWidth = svg ? svg.getBoundingClientRect().width : 900;
    var bangaloreX = svgWidth * (773 / 1110);
    mapScroll.scrollLeft = bangaloreX - mapScroll.offsetWidth / 2;
    initMapClicks(svg);
  }

  // Second map — scaled, no scroll wrapper
  var secondMapDiv = document.querySelector('.map-wrapper > div:last-child');
  if (secondMapDiv) {
    initMapClicks(secondMapDiv.querySelector('svg'));
  }
};
// Run on page load for any SVGs already in the DOM
window.mciInitMaps();
